import { useCallback, useMemo } from 'react';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { FieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/transitional/components/View';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OptionPreselect = ({
  value = '',
  fieldType = '',
  selectedOptions = [],
  handlePreselect = () => {},
  children = /*#__PURE__*/_jsx(_Fragment, {})
}) => {
  const isChecked = useMemo(() => {
    return selectedOptions.includes(value);
  }, [selectedOptions, value]);
  const handleChange = useCallback(() => handlePreselect(value), [value, handlePreselect]);
  if (fieldType === FieldTypes.CHECKBOX) {
    return /*#__PURE__*/_jsxs(TFlex, {
      children: [/*#__PURE__*/_jsx(Checkbox, {
        alignment: 'center',
        "aria-label": `${value}`,
        checked: isChecked,
        onChange: handleChange
      }), /*#__PURE__*/_jsx(View, {
        paddingInlineStart: "200",
        as: "div",
        children: children
      })]
    });
  }
  return /*#__PURE__*/_jsxs(TFlex, {
    children: [/*#__PURE__*/_jsx(RadioInput, {
      alignment: 'center',
      "aria-label": `${value}`,
      onChange: handleChange,
      checked: isChecked
    }), children]
  });
};
export default OptionPreselect;